<template>
  <div>
    <NavBar v-if="!componente" />
    <AuthBySessionExpired v-if="!componente" />
    <div class="container">
      <div v-if="!componente" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pl-0">
        <v-btn class="btn-return" v-on:click="handleToBack">
          <i class="fas fa-arrow-left mr-2 text-twenty"></i> VOLTAR
        </v-btn>
      </div>
      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <a
            @click="step = 'CHECAGEM'"
            class="nav-link active"
            id="nav-checagem"
            data-toggle="tab"
            href="#checagem"
            role="tab"
            aria-controls="checagem"
            aria-selected="true"
            >CHECAGEM DE MEDICAMENTOS</a
          >
          <a
            @click="step = 'PRESCRICAO_NORMAL'"
            class="nav-link"
            id="nav-prescricao-normal"
            data-toggle="tab"
            href="#prescricao-normal"
            role="tab"
            aria-controls="prescricao-normal"
            aria-selected="false"
            >PRESCRIÇÃO</a
          >
          <a
            @click="step = 'PRESCRICAO_LONGO_PRAZO'"
            class="nav-link"
            id="nav-prescricao-longo-prazo"
            data-toggle="tab"
            href="#prescricao-longo-prazo"
            role="tab"
            aria-controls="prescricao-longo-prazo"
            aria-selected="false"
            >PRESCRIÇÃO LONGO PRAZO</a
          >
        </div>
      </nav>
      <div class="tab-content" id="nav-tabContent">
        <div
          v-if="step == 'CHECAGEM'"
          class="tab-pane fade show active"
          id="checagem"
          role="tabpanel"
          aria-labelledby="nav-checagem"
        >
          <CheckNormal />
        </div>
        <div
          v-if="step == 'PRESCRICAO_NORMAL'"
          class="tab-pane fade"
          id="prescricao-normal"
          role="tabpanel"
          aria-labelledby="nav-prescricao-normal"
        >
          <PrescriptionNormal />
        </div>
        <div
          v-if="step == 'PRESCRICAO_LONGO_PRAZO'"
          class="tab-pane fade"
          id="prescricao-longo-prazo"
          role="tabpanel"
          aria-labelledby="nav-prescricao-longo-prazo"
        >
          <PrescriptionLongTerm />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import CheckNormal from "../templates/Resident/DailyRoutine/Check/Normal";

import PrescriptionNormal from "../templates/Resident/DailyRoutine/Prescription/Normal";

import PrescriptionLongTerm from "../templates/Resident/DailyRoutine/Prescription/LongTerm";

import routes from "../routes";

import { userData } from "../lib/functions";

export default {
  name: "Check",
  components: {
    NavBar,
    AuthBySessionExpired,
    CheckNormal,
    PrescriptionNormal,
    PrescriptionLongTerm,
  },
  props: {
    componente: { type: Boolean, default: false }
  },
  data() {
    return {
      step: "CHECAGEM",
      rest_home_id: "",
      resident_id: "",
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    async retrieve() {
      let { rest_home_id } = userData();

      this.rest_home_id = rest_home_id;

      const { id } = routes.history.current.params;

      this.resident_id = id;
    },
    handleToBack: () => routes.go(-1),
  },
};
</script>
